export const productPhotoName = (code, index = 0) => `${String(code || "PRODUCT").replace(/[<>:"/\\|?*\x00-\x1f]/g, "_").replace(/^[ .]+|[ .]+$/g, "").slice(0, 100) || "PRODUCT"}_${index + 1}.jpg`;

export function savePhotoBlob(blob, filename) {
  const url = URL.createObjectURL(blob), link = document.createElement("a");
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
  // Safari may hand the file to its download sheet asynchronously.
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function originalAsJpeg(file) {
  if (file.type === "image/jpeg" || /\.jpe?g$/i.test(file.name || "")) return file;
  let image, url;
  try {
    if (typeof createImageBitmap === "function") image = await createImageBitmap(file);
    else {
      url = URL.createObjectURL(file); image = new Image();
      await new Promise((resolve, reject) => { image.onload = resolve; image.onerror = reject; image.src = url; });
    }
    const canvas = document.createElement("canvas");
    canvas.width = image.naturalWidth || image.width; canvas.height = image.naturalHeight || image.height;
    const context = canvas.getContext("2d"); context.fillStyle = "white"; context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.97));
    if (!blob) throw new Error("JPG-conversie niet beschikbaar");
    return blob;
  } catch {
    throw new Error("Deze originele foto kan op dit apparaat niet offline naar JPG worden omgezet. Maak verbinding en probeer JPG afdruk opnieuw; het origineel blijft bewaard.");
  } finally { image?.close?.(); if (url) URL.revokeObjectURL(url); }
}